import { FriendListScreenNavigationProps } from "./types"
import React, { useCallback, useMemo, useState } from "react"
import { observer } from "mobx-react-lite"
import { useFocusEffect } from "~/ui/react-navigation-stub"
import FriendList from "./friend-list-screen"
import FriendSentList from "./friend-sent-list-screen"
import { TextTabs } from "~components/TextTabs"
import { useStores } from "~models"
import { PageRoot } from "~screens/page-root"

const TAB_MAP = {
  receive: FriendList,
  send: FriendSentList,
}
const FriendListScreen: React.FC<FriendListScreenNavigationProps> = () => {
  const { friendStore } = useStores()
  const tabs = useMemo(
    () => [
      { label: "收到的申请", value: "receive", count: friendStore.friendsCount },
      { label: "发起的申请", value: "send", count: friendStore.friendSentListCount },
    ],
    [friendStore.friendsCount, friendStore.friendSentListCount],
  )
  const [tab, setTab] = useState("receive")
  const onTabPress = (item: string) => {
    setTab(item)
  }
  const Com = useMemo(() => TAB_MAP[tab], [tab])

  useFocusEffect(
    useCallback(() => {
      friendStore.refreshFriendLists()
    }, [friendStore]),
  )

  return (
    <PageRoot>
      <TextTabs
        height={36}
        tabs={tabs}
        active={tab}
        onChange={(item) => onTabPress(typeof item === "string" ? item : item.value)}
      />
      <Com />
    </PageRoot>
  )
}

export default observer(FriendListScreen)
